<qrcode
  *ngIf="qrdata"
  [qrdata]="qrdata"
  [cssClass]="'qrcore-wrapper'"
  [width]="appConfig.QRCode.smallScreen.size"
  errorCorrectionLevel="M"
></qrcode>
